/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@env/environment';

import { Observable } from 'rxjs';

import { UserProfileService } from '@app/one-core/services/user-profile.service';

@Injectable()
export class DataSupplierInterceptor implements HttpInterceptor {
  private secureRoutes = [
    environment.services.assetApi,
    environment.services.catalogApi,
    environment.services.idpApi,
    environment.services.notificationsApi,
    environment.services.notificationsHub,
    environment.services.oneHubApi,
    environment.services.portalApi,
    environment.services.referenceApi,
    environment.services.autocareApi,
    environment.services.searchApi,
    environment.services.autocareReferenceApi,
  ];

  constructor(private userProfileService: UserProfileService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.secureRoutes.some((route) => request.url.startsWith(route))) {
      return next.handle(request);
    }

    const userTenant = this.userProfileService.getTenant();

    if (userTenant) {
      const newRequest = request.clone({
        headers: request.headers.set('one-datasupplier-id', userTenant.dataSupplierId.toString()),
      });
      return next.handle(newRequest);
    }

    return next.handle(request);
  }
}
